<template lang="html">
    <v-dialog
            v-model="isVisible"
            scrollable
            max-width="700"
    >
        <v-card class="grey lighten-4">
            <v-toolbar flat color="grey lighten-4">
                <v-icon class="mr-1">mdi-clock-outline</v-icon>
                <v-toolbar-title class="text--secondary">DateTime</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleDateTimePanel()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <template v-slot:extension>
                    <v-tabs v-model="dateTabItem" grow>
                        <v-tab>Quick</v-tab>
                        <v-tab>Relative</v-tab>
                        <v-tab>Absolute</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>

            <v-divider></v-divider>

            <v-card-text class="pa-1">
                <v-tabs-items v-model="dateTabItem" grow>

                    <v-tab-item>
                        <date-time-quick/>
                    </v-tab-item>

                    <v-tab-item>
                        <date-time-relative/>
                    </v-tab-item>

                    <v-tab-item>
                        <date-time-absolute tab-index="2"/>
                    </v-tab-item>

                </v-tabs-items>
            </v-card-text>
        </v-card>
    </v-dialog>

</template>

<script>
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import {mapActions} from 'vuex'
    import DateTimeQuick from "@/components/home/date/DateTimeQuick";
    import DateTimeRelative from "@/components/home/date/DateTimeRelative";
    import DateTimeAbsolute from "@/components/home/date/DateTimeAbsolute";


    export default {
        components: {DateTimeAbsolute, DateTimeRelative, DateTimeQuick},
        data: () => ({
            tab: ''
        }),
        computed: {
            isVisible: {
                get() {
                    return this.$store.getters[`${SEARCH_NS}/isDateTimePanelVisible`]
                },
                set() {
                    this.$store.dispatch(SEARCH_NS + '/toggleDateTimePanel')
                }
            },
            dateTabItem: {
                get() {
                    return this.$store.getters[`${SEARCH_NS}/dateTabItem`]
                },
                set(index) {
                    this.$store.dispatch(SEARCH_NS + '/updateDateTabItem', index)
                }
            }
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                'toggleDateTimePanel'
            ])
        }
    }
</script>